import { useNavigate } from 'react-router-dom';
import { FileText, BookOpen, MessageSquare, Settings, PlusCircle, ScrollText } from 'lucide-react';

export default function Welcome() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-navy-800 rounded-xl p-8 shadow-sm">
        <h1 className="text-3xl font-bold text-navy-900 dark:text-white">Bem-vindo(a) ao App Bônus dos Cursos do prof. Vinicius</h1>
        <p className="mt-4 text-navy-600 dark:text-navy-300 max-w-2xl">
          Explore nossas ferramentas integradas com inteligência artificial para otimizar sua rotina jurídica. Escolha uma das opções abaixo para começar.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        
        {/* Card Novo Parecer */}
        <div 
          onClick={() => navigate('/new')}
          className="bg-white dark:bg-navy-800 p-6 rounded-xl shadow-sm border border-navy-100 dark:border-navy-700 hover:border-accent-500 hover:shadow-md cursor-pointer transition-all"
        >
          <div className="bg-accent-50 dark:bg-accent-900/20 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
            <PlusCircle className="text-accent-500 h-6 w-6" />
          </div>
          <h3 className="text-xl font-semibold text-navy-900 dark:text-white">Novo Parecer</h3>
          <p className="mt-2 text-navy-600 dark:text-navy-300 text-sm">
            Gerador inteligente. Crie novas análises jurídicas com o auxílio da nossa IA.
          </p>
        </div>

        {/* Card Histórico de Pareceres */}
        <div 
          onClick={() => navigate('/pareceres')}
          className="bg-white dark:bg-navy-800 p-6 rounded-xl shadow-sm border border-navy-100 dark:border-navy-700 hover:border-accent-500 hover:shadow-md cursor-pointer transition-all"
        >
          <div className="bg-accent-50 dark:bg-accent-900/20 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
            <FileText className="text-accent-500 h-6 w-6" />
          </div>
          <h3 className="text-xl font-semibold text-navy-900 dark:text-white">Histórico de Pareceres</h3>
          <p className="mt-2 text-navy-600 dark:text-navy-300 text-sm">
            Acesse seus pareceres anteriores e gerencie suas análises.
          </p>
        </div>

        {/* Card Consulta Especializada */}
        <div 
          onClick={() => navigate('/consulta-especializada')}
          className="bg-white dark:bg-navy-800 p-6 rounded-xl shadow-sm border border-navy-100 dark:border-navy-700 hover:border-accent-500 hover:shadow-md cursor-pointer transition-all"
        >
          <div className="bg-accent-50 dark:bg-accent-900/20 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
            <BookOpen className="text-accent-500 h-6 w-6" />
          </div>
          <h3 className="text-xl font-semibold text-navy-900 dark:text-white">Consulta Especializada</h3>
          <p className="mt-2 text-navy-600 dark:text-navy-300 text-sm">
            Tire dúvidas específicas utilizando nosso assistente focado em jurisprudência.
          </p>
        </div>

        {/* Card Atos Administrativos */}
        <div
          onClick={() => navigate('/atos-administrativos')}
          className="bg-white dark:bg-navy-800 p-6 rounded-xl shadow-sm border border-navy-100 dark:border-navy-700 hover:border-accent-500 hover:shadow-md cursor-pointer transition-all"
        >
          <div className="bg-accent-50 dark:bg-accent-900/20 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
            <ScrollText className="text-accent-500 h-6 w-6" />
          </div>
          <h3 className="text-xl font-semibold text-navy-900 dark:text-white">Atos Administrativos</h3>
          <p className="mt-2 text-navy-600 dark:text-navy-300 text-sm">
            Consulte modelos prontos de portarias, decretos, resoluções e outros atos administrativos.
          </p>
        </div>

        {/* Card Hub de IAs */}
        <div 
          onClick={() => navigate('/chat')}
          className="bg-white dark:bg-navy-800 p-6 rounded-xl shadow-sm border border-navy-100 dark:border-navy-700 hover:border-accent-500 hover:shadow-md cursor-pointer transition-all"
        >
          <div className="bg-accent-50 dark:bg-accent-900/20 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
            <MessageSquare className="text-accent-500 h-6 w-6" />
          </div>
          <h3 className="text-xl font-semibold text-navy-900 dark:text-white">Hub de IAs</h3>
          <p className="mt-2 text-navy-600 dark:text-navy-300 text-sm">
            Acesse diversas ferramentas de inteligência artificial em um ambiente unificado de chat.
          </p>
        </div>

        {/* Card Configurações */}
        <div 
          onClick={() => navigate('/settings')}
          className="bg-white dark:bg-navy-800 p-6 rounded-xl shadow-sm border border-navy-100 dark:border-navy-700 hover:border-accent-500 hover:shadow-md cursor-pointer transition-all"
        >
          <div className="bg-accent-50 dark:bg-accent-900/20 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
            <Settings className="text-accent-500 h-6 w-6" />
          </div>
          <h3 className="text-xl font-semibold text-navy-900 dark:text-white">Configurações</h3>
          <p className="mt-2 text-navy-600 dark:text-navy-300 text-sm">
            Ajuste suas preferências de conta e configurações do sistema.
          </p>
        </div>

      </div>
    </div>
  );
}
